<div class="sw-cms-el-product-finder">
    
    
    <div class="sw-cms-el-product-finder-placeholder">
        <mt-icon name="regular-search" size="48px"></mt-icon>
        <p>{{ $tc('sw-cms.elements.productFinder.placeholder') }}</p>
    </div>
</div>